export default __webpack_public_path__ + "static/media/support.636df977.svg";